import { useLocalStorage } from '@/lib/helpers/storage'

/**
 * @param {import('@nuxtjs/axios').NuxtAxiosInstance} api
 */
export default api => {
  return {
    /**
     * Track an event when a user downloads a file
     *
     * @param {Object} logo The logo object being downloaded
     * @returns
     */
    async trackLogoFileDownloaded(logo) {
      if (!!useLocalStorage().getItem('logo-file-download-tracker')) {
        return
      }

      useLocalStorage().setItem('logo-file-download-tracker', logo.id)

      const res = await api.post('/api/v2/mailing/subscribe/downloaded', {
        logo: logo.id,
      })

      return res.data
    },
  }
}
